// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".folder-picker-section-title {\n  font-weight: 600;\n  margin-bottom: 0.75rem;\n  line-height: 17px;\n  font-size: 14px !important;\n  letter-spacing: normal;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
